module.exports = __webpack_public_path__ + "static/media/cover.11250ee5.webp";